module.exports = __webpack_public_path__ + "static/img/gongzhong.e87d7c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gongzhong.jpg
// module id = c+f9
// module chunks = 1